import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    window.open('https://digitalsmart.club/cart/52265316286776:1', '_blank');
    onClick?.(e);
  };
  return <button className={`
        group relative inline-flex items-center justify-center gap-3 
        bg-gold hover:bg-gold-light text-navy font-bold text-lg md:text-xl 
        py-4 px-8 rounded-lg shadow-lg hover:shadow-xl 
        transition-all duration-300 transform hover:-translate-y-1
        ${className}
      `} onClick={handleClick} {...props} data-id="element-1">
      <span data-id="element-2">{children}</span>
      <ArrowRight className="w-6 h-6 transition-transform duration-300 group-hover:translate-x-1" data-id="element-3" />
    </button>;
}